import { render, staticRenderFns } from "./OmReportsList.vue?vue&type=template&id=4125db2c&"
import script from "./OmReportsList.vue?vue&type=script&lang=js&"
export * from "./OmReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports